<template lang="html">
    <div>
        <v-dialog v-model="ListContactDialog" transition="dialog-bottom-transition" persistent>
            <v-overlay :value="progress">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-card :style="stylechat" class="pa-2">
              <v-layout row wrap justify-start align-center class="pa-5" v-if="ListContactDetail.type === 'forward'">
                    <v-col cols="2" justify="start" align="start" class="pl-0 pr-0 pt-0 pb-0">
                        <v-icon class="fz-30 cursor" @click="closeDialog">mdi-close</v-icon>
                    </v-col>
                    <v-col cols="8" justify="center" align="center" class="pa-0">
                        <span class="tab-title">{{ $t('Dialog.forward.header') }}</span>
                    </v-col>
                    <v-col cols="2" justify="center" align="center" class="pr-0 pl-0 pt-0 pb-0">
                        <span class="icon-color-cancel cursor"
                        @click="closeDialog">{{ $t('AnswerQuestion.cancel') }}</span>
                        <span :class="selectedRoomForward.length !== 0 ? 'icon-color cursor ml-3' : 'icon-color-edit ml-3'"
                            @click="sendForward()">{{ $t('AnswerQuestion.forward') }}</span>
                    </v-col>
                </v-layout>
              <v-layout row wrap justify-start align-center class="pa-5" v-if="ListContactDetail.type === 'send-contact'">
                    <v-col cols="2" justify="start" align="start" class="pl-0 pr-0 pt-0 pb-0">
                        <v-icon class="fz-30 cursor" @click="closeDialog">mdi-close</v-icon>
                    </v-col>
                    <v-col cols="8" justify="center" align="center" class="pa-0">
                        <span class="tab-title">{{ $t('Dialog.account') }}</span>
                    </v-col>
                    <v-col cols="2" justify="center" align="center" class="pr-0 pl-0 pt-0 pb-0">
                        <span :class="contact_select !== '' ? 'icon-color cursor' : 'icon-color-edit'"
                            @click="sendContact()">{{ $t('AnswerQuestion.ok') }}</span>
                    </v-col>
                </v-layout>
                <v-divider class="mt-4 mb-2"></v-divider>
                <v-layout row wrap justify-start align-center class="pt-5 pl-5 pr-5 pb-3">
                    <v-text-field ref="search" 
                      v-model="search" 
                      :placeholder="ListContactDetail.type === 'send-contact' ? $t('LeftSide.addFiend.searching') : $t('LeftSide.searching')"
                      prepend-inner-icon="mdi-magnify" 
                      solo 
                      dense 
                      hide-details 
                      clearable>
                    </v-text-field>
                </v-layout>
                <v-layout v-if="ListContactDetail.type === 'forward'" row wrap justify-start align-start class="pl-5 pr-5 pb-5 mt-0">
                  <a-tabs default-active-key="1" @change="callback" style="width: 100%;">
                    <a-tab-pane key="1" style="width: 100%;">
                      <span slot="tab">
                        {{ $t('LeftSide.header.friend')}} ({{ FilterListFriend.length }})
                      </span>
                      <v-list class="list-overflow" v-if="FilterListFriend.length === 0">
                        <v-icon class="icon-color"
                            style="justify-content: center; display: flex; margin-top: 50px; font-size: 50px; overflow: hidden;">fa-solid
                            fa-list</v-icon>
                        <h4 class="mt-5" style="justify-content: center; display: flex;">
                            {{ $t('LeftSide.noDataSearching') }}</h4>
                    </v-list>
                    <v-list v-else class="list-overflow-forward">
                            <template v-for="(item, index) in FilterListFriend">
                                <v-list-item :key="item.tokenuser">
                                        <v-list-item-avatar>
                                            <v-img v-if="item.profilepicture" :src="item.profilepicture"
                                                class="img-position"></v-img>
                                            <img v-else-if="item.type === 'bot'"
                                                :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt=""
                                                class="img-position">
                                            <img v-else-if="item.type === 'business'"
                                                :src="`${publicPath}/assets/img/default_profile/business-white.png`"
                                                alt="" class="img-position">
                                            <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`"
                                                alt="" class="img-position">
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title v-text="item.name" class="text-overflow">
                                            </v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-action class="pb-2">
                                            <v-checkbox v-model="selectedRoomForward" :value="item.tokenroom">

                                            </v-checkbox>
                                        </v-list-item-action>
                                </v-list-item>
                                <v-divider v-if="index < FilterListFriend.length - 1" :key="index"></v-divider>
                            </template>
                    </v-list>
                    </a-tab-pane>
                    <a-tab-pane key="2">
                      <span slot="tab">
                        {{ $t('LeftSide.friend.group')}} ({{ FilterListGroup.length }})
                      </span>
                      <v-list class="list-overflow" v-if="FilterListGroup.length === 0">
                        <v-icon class="icon-color"
                            style="justify-content: center; display: flex; margin-top: 50px; font-size: 50px; overflow: hidden;">fa-solid
                            fa-list</v-icon>
                        <h4 class="mt-5" style="justify-content: center; display: flex;">
                            {{ $t('LeftSide.noDataSearching') }}</h4>
                    </v-list>
                    <v-list v-else class="list-overflow-forward">
                            <template v-for="(item, index) in FilterListGroup">
                                <v-list-item :key="item.tokenroom">
                                        <v-list-item-avatar>
                                            <v-img v-if="item.picture" :src="item.picture"
                                                class="img-position"></v-img>
                                            <img v-else
                                                :src="`${publicPath}/assets/img/default_profile/group-white.png`" alt=""
                                                class="img-position">
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title v-text="item.name" class="text-overflow">
                                            </v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-action class="pb-2">
                                            <v-checkbox v-model="selectedRoomForward" :value="item.tokenroom">
                                            </v-checkbox>
                                        </v-list-item-action>
                                </v-list-item>
                                <v-divider v-if="index < FilterListGroup.length - 1" :key="index"></v-divider>
                            </template>
                    </v-list>
                    </a-tab-pane>
                  </a-tabs>
                </v-layout>
                <v-layout v-if="ListContactDetail.type === 'send-contact'" row wrap justify-start align-start class="pl-5 pr-5 pb-5 mt-0">
                    <v-list class="list-overflow" v-if="FilterListFriend.length === 0">
                        <v-icon class="icon-color"
                            style="justify-content: center; display: flex; margin-top: 50px; font-size: 50px; overflow: hidden;">fa-solid
                            fa-list</v-icon>
                        <h4 class="mt-5" style="justify-content: center; display: flex;">
                            {{ $t('LeftSide.noDataSearching') }}</h4>
                    </v-list>
                    <v-list v-else class="list-overflow">
                        <v-subheader v-if="FilterListFriend.length !== 0">{{ $t('LeftSide.header.friend') }}
                            ({{ FilterListFriend.length }})</v-subheader>
                        <v-radio-group v-model="contact_select" column class="mt-1">
                            <template v-for="(item, index) in FilterListFriend">
                                <v-list-item :key="item.tokenuser">
                                    <template v-slot:default="{ active, toggle }">
                                        <v-list-item-avatar>
                                            <v-img v-if="item.profilepicture" :src="item.profilepicture"
                                                class="img-position"></v-img>
                                            <img v-else-if="item.type === 'bot'"
                                                :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt=""
                                                class="img-position">
                                            <img v-else-if="item.type === 'business'"
                                                :src="`${publicPath}/assets/img/default_profile/business-white.png`"
                                                alt="" class="img-position">
                                            <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`"
                                                alt="" class="img-position">
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title v-text="item.name" class="text-overflow">
                                            </v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-action class="pb-2">
                                            <v-radio :value="item"></v-radio>
                                        </v-list-item-action>
                                    </template>
                                </v-list-item>
                                <v-divider v-if="index < FilterListFriend.length - 1" :key="index"></v-divider>
                            </template>
                        </v-radio-group>
                    </v-list>
                </v-layout>
            </v-card>
        </v-dialog>
        <ErrorDialog :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail"
            @closeAlertDialog="closeAlertDialog" />
        <WarningDialog :WarningDialog="WarningDialog" :WarningDialogDetail="WarningDialogDetail"
            @emitWarning="emitWarning" @closeAlertDialog="closeAlertDialog" />
    </div>
</template>

<script>
import WarningDialog from '@/components/Alert/Warning'
import ErrorDialog from '@/components/Alert/Error'
var _ = require('lodash')
export default {
    props: {
        ListContactDialog: Boolean,
        ListContactDetail: {}
    },
    data() {
        return {
            selectedRoomForward: [],
            contact_select: '',
            publicPath: process.env.VUE_APP_BASE_PATH,
            selected: [],
            FriendList: [],
            GroupList: [],
            ErrorDialogDetail: {},
            ErrorDialog: false,
            WarningDialogDetail: {},
            WarningDialog: false,
            data_user: {},
            edit_member: false,
            member_active: [],
            member_pending: [],
            progress: false,
            search: '',
            stylechat: {
                "--ListContact-HeaderColor": "white",
                "--ListContact-TabBackground": "white",
                "--ListContact-Icon": "gray",
                "--ListContact-IconActive": "#2662ae",
                "--ListContact-Background": "white",
                "--ListContact-FontSize": "18px",
                "--ListContact-FontSize-Title": "24px",
                "--ListContact-FontColor": "back",
                "--ListContact-FontSize-Status": "16px",
                "--ListContact-FontColor-Status": "grey",
                "--ListContact-Background-Input": "#E2E1E3",
                "--ListContact-Color-Button": "#EFF2FE",
                "--ListContact-FontColor-Button": "#2662ae",
                "--ListContact-FontColor-Block-Button": "#cb1002",
                "--ListContact-FontColor-Dis-Button": "#e2e1e3",
                "--ListContact-Btn-Confirm-Background": "#2662ae",
                "--ListContact-Btn-Confirm-Color": "white",
                "--ListContact-Btn-Confirm-FontSize": "18px",
                "--ListContact-Btn-Cancel-Background": "white",
                "--ListContact-Btn-Cancel-Color": "#2662ae",
                "--ListContact-Btn-Cancel-FontSize": "18px",
                "--ListContact-Btn-Leave-Background": "white",
                "--ListContact-Btn-Leave-Color": "#ff5252",
                "--ListContact-Btn-Leave-FontSize": "18px"
            },
        }
    },
    components: {
        WarningDialog,
        ErrorDialog
    },
    computed: {
        FilterListFriend() {
            if (this.search !== '' && this.search !== null) {
                return this.FriendList.filter(post => {
                    return post.name.toLowerCase().includes(this.search.toLowerCase())
                })
            } else {
                return this.FriendList
            }
        },
        FilterListGroup() {
          if (this.search !== '' && this.search !== null) {
                return this.GroupList.filter(post => {
                    return post.name.toLowerCase().includes(this.search.toLowerCase())
                })
            } else {
                return this.GroupList
            }
        }
    },
    watch: {
        ListContactDialog() {
            if (this.ListContactDialog) {
              // console.log("Listcontact detail =>", this.ListContactDetail);
                this.getListFriend()
                if (this.ListContactDetail.type === 'forward') {
                  this.getListGroup()
                }
            }
        },
        // selectedRoomForward (val) {
        //   console.log("selectedRoomForward =>", val);
        // },
    },
    created() {
        // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
        var user_profile = ''
        if (JSON.parse(this.$cookie.get('user-profile') == null)) {
            user_profile = JSON.parse(localStorage.getItem('user-profile'))
        } else {
            user_profile = JSON.parse(this.$cookie.get('user-profile'))
        }
        this.data_user = user_profile['account']['profile']
    },
    methods: {
      callback(key) {
        console.log(key);
      },
        sendForward() {
          // console.log("sendForward");
          this.progress = true
            this.axios.post(process.env.VUE_APP_API_message + '/forward_file_message', {
                list_tokenmessage: this.ListContactDetail.value,
                list_tokenroom: this.selectedRoomForward,
                tokenuser: this.data_user.tokenuser
            }).then((response) => {
                if (response.data.status === 'success') {
                    this.progress = false
                    this.closeDialog()
                }
                // console.log(this.FriendList)
            }).catch(err => {
                console.log(err)
                this.selectedRoomForward = []
                this.progress = false
                this.ErrorDialogDetail = {
                    title: 'Error',
                    text: this.$t('Alert.Fail.default.somethingWrong')
                }
                this.ErrorDialog = true
            })
        },
        sendContact() {
            if (this.contact_select !== '') {
                this.$emit('emitComponents', {
                    name: this.ListContactDetail.type,
                    value: {
                        list_friend: this.contact_select
                    }
                })
                this.contact_select = "";
            }
        },
        getListGroup () {
          this.progress = true
            this.axios.post(process.env.VUE_APP_API_GO + '/v1/get-list-group', {
                tokenuser: this.data_user.tokenuser
            }).then((response) => {
                if (response.data.status === 'success') {
                    this.progress = false
                    this.GroupList = response.data['list_active_group']
                }
                // console.log(this.FriendList)
            }).catch(err => {
                console.log(err)
                this.selectedRoomForward = []
                this.progress = false
                this.ErrorDialogDetail = {
                    title: 'Error',
                    text: this.$t('Alert.Fail.default.somethingWrong')
                }
                this.ErrorDialog = true
            })
        },
        getListFriend() {
            this.progress = true
            this.axios.post(process.env.VUE_APP_API_GO + '/v1/get-list-friend', {
                tokenuser: this.data_user.tokenuser
            }).then((response) => {
                if (response.data.status === 'success') {
                    this.progress = false
                    this.FriendList = response.data['list_friend']
                    this.FriendList = _.differenceBy(this.FriendList, this.member_active, 'tokenuser')
                    this.FriendList = _.differenceBy(this.FriendList, this.member_pending, 'tokenuser')
                }
                // console.log(this.FriendList)
            }).catch(err => {
                console.log(err)
                this.selected = []
                this.progress = false
                this.ErrorDialogDetail = {
                    title: 'Error',
                    text: this.$t('Alert.Fail.default.somethingWrong')
                }
                this.ErrorDialog = true
            })
        },
        closeAlertDialog(data) {
            if (data.type === 'warning') {
                this.WarningDialog = data.value
            } else if (data.type === 'err') {
                this.ErrorDialog = data.value
            }
        },
        emitWarning(item) {
            this.WarningDialog = false
            if (item.type === 'kickgroup') {
                this.kickGroup(item)
            } else if (item.type === 'cancelinvite') {
                this.cancelInvite(item)
            }
        },
        closeDialog() {
            this.selected = []
            this.search = ''
            this.member_active = []
            this.member_pending = []
            this.FriendList = []
            this.contact_select = ''
            this.selectedRoomForward = []
            this.$emit('closeComponents', {
                name: this.ListContactDetail.type === 'send-contact' ? 'listcontact': 'forward',
                value: false
            })
        },
    },
}
</script>

<style lang="css" scoped>
.cursor {
    cursor: pointer !important;
}

.checkbox-color {
    color: var(--ListContact-IconActive) !important;
}

>>>.v-application .elevation-10 {
    box-shadow: none !important;
}

>>>.theme--light.v-sheet {
    box-shadow: none !important;
}
.list-overflow-forward {
  height: calc(100vh - 300px) !important;
    overflow-y: auto;
    width: 100% !important;
}
.list-overflow-forward::-webkit-scrollbar {
    width: 3px;
}

.list-overflow-forward::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(0, 0, 0, .1);
}
.list-overflow {
    height: calc(100vh - 250px) !important;
    overflow-y: auto;
    /* background-color: bisque; */
    width: 100% !important;
}

.list-overflow::-webkit-scrollbar {
    width: 3px;
}

.list-overflow::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(0, 0, 0, .1);
}

.list-overflow-select {
    height: calc(100vh - 210px) !important;
    overflow-y: auto;
    /* background-color: bisque; */
    width: 100% !important;
}

.list-overflow-select::-webkit-scrollbar {
    width: 3px;
}

.list-overflow-select::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(0, 0, 0, .1);
}

/* >>>.v-input__slot {
    background-color: var(--ListContact-Background-Input) !important;
    border-radius: 10px !important;
  } */
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
    box-shadow: none !important;
    background-color: var(--ListContact-Background-Input) !important;
    border-radius: 10px !important;
}

>>>.v-dialog {
    /* border-radius: 0;
    margin: 0;
    height: 100% ;
    position: fixed !important;
    top: 0;
    left: 0;
    overflow: hidden !important; */
    border-radius: 4px !important;
    margin: 24px !important;
    overflow-y: hidden !important;
    pointer-events: auto !important;
    transition: .3s cubic-bezier(.25, .8, .25, 1) !important;
    width: 60% !important;
    z-index: inherit !important;
    outline: none !important;
    box-shadow: 0 11px 15px -7px rgba(0, 0, 0, .2), 0 24px 38px 3px rgba(0, 0, 0, .14), 0 9px 46px 8px rgba(0, 0, 0, .12) !important;
}

>>>.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
}

.icon-color-edit {
    color: var(--ListContact-Icon) !important;
}

.icon-color {
    color: var(--ListContact-IconActive) !important;
}
.icon-color-cancel {
  color: var(--ListContact-FontColor-Block-Button) !important;
}
.btn-confirm {
    background-color: var(--ListContact-Btn-Confirm-Background) !important;
    color: var(--ListContact-Btn-Confirm-Color) !important;
    font-size: var(--ListContact-Btn-Confirm-FontSize) !important;
    font-weight: 600;
}

.btn-cancel {
    background-color: var(--ListContact-Btn-Cancel-Background) !important;
    color: var(--ListContact-Btn-Cancel-Color) !important;
    font-size: var(--ListContact-Btn-Cancel-FontSize) !important;
    font-weight: 600;
}

.btn-leave {
    background-color: var(--ListContact-Btn-Leave-Background) !important;
    color: var(--ListContact-Btn-Leave-Color) !important;
    font-size: var(--ListContact-Btn-Leave-FontSize) !important;
    font-weight: 600;
}

.img-position {
    object-fit: cover;
    object-position: 50% 0;
    border-style: solid;
    border-width: thin;
    border-color: #e8e8e8;
}

.layout-page {
    /* height: calc(100vh - 64px) !important; */
    height: 100vh !important;
    overflow: hidden !important;
    background-color: var(--ListContact-Background) !important;
}

.fz-30 {
    font-size: 30px;
}

.text-transform {
    text-transform: none;
}

.text-title {
    font-size: var(--ListContact-FontSize-Title) !important;
    color: var(--ListContact-FontColor) !important;
    font-weight: 600;
}

.tab-title {
    color: var(--ListContact-FontColor) !important;
    font-size: var(--ListContact-FontSize) !important;
    font-weight: 600;
}

.tab-title-status {
    color: var(--ListContact-FontColor-Status) !important;
    font-size: var(--ListContact-FontSize-Status) !important;
}

.text-overflow {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 70vw;
}
</style>